var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"muted":""},domProps:{"muted":true},on:{"click":function($event){return _vm.togglePause()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }